










































































import BaseComponent from '@/components/base-component.vue';
import UiHeader from '@/components/UI/header.vue';
import Component from 'vue-class-component';
import * as service from '@/services/calendar';
import ListMessages from '@/components/UI/list-messages.vue';
import PermissionAuth from '@/components/UI/permission-auth.vue';
import HolidayForm from '@/components/calendar/holiday-form.vue';
import UiAutocompleteUF from '@/components/UI/autocomplete-uf.vue';
import UiAutocompleteCity from '@/components/UI/autocomplete-city.vue';
import { Watch } from 'vue-property-decorator';

@Component({
  components: {
    UiHeader,
    ListMessages,
    PermissionAuth,
    HolidayForm,
    UiAutocompleteUF,
    UiAutocompleteCity
  }
})
export default class HolidayCalendar extends BaseComponent {
  currentYear = new Date().getFullYear();

  filters = {
    ano: this.currentYear,
    tipo: null,
    uf: null,
    municipio: null
  };

  years = [];
  items = [];
  loading = false;
  error = false;

  openForm = false;
  idSelected = null;

  public headers: any = [
    { text: 'Dia', value: 'data', sortable: true },
    { text: 'Nome', value: 'nome', sortable: true },
    { text: 'Tipo', value: 'dsTipo', sortable: true },
    { text: 'Estado', value: 'uf', sortable: true },
    { text: 'Município', value: 'municipio', sortable: true },
    { text: 'Recorrente', value: 'recorrente', sortable: true },
    { text: '', value: '', sortable: false, width: '30' }
  ];

  beforeMount() {
    for (var i = -5; i <= 5; i++) {
      this.years.push(this.currentYear + i);
    }
  }

  mounted() {
    this.load();
  }

  onChangeFilters() {
    this.load();
  }

  load() {
    this.loading = true;
    this.error = false;
    service.listCalendarHolidays(this.filters).subscribe(
      (res) => {
        this.items = res;
        this.loading = false;
      },
      (error) => {
        this.showToastApiError(error);
        this.loading = false;
        this.error = true;
      }
    );
  }

  openItem(item) {
    this.idSelected = item.id;
    this.openForm = true;
  }

  newItem() {
    this.idSelected = null;
    this.openForm = true;
  }

  onCloseForm() {
    this.openForm = false;
  }

  onSave() {
    this.load();
    this.onCloseForm();
  }

  @Watch('filters.tipo')
  onTipoChange(t) {
    if (!t || t == 'N') {
      this.filters.uf = null;
      this.filters.municipio = null;
    } else if (!t || t == 'E') {
      this.filters.municipio = null;
    }
  }

  public deleteItem(item): void {
    const deleteAction = () => {
      this.loader.start('Processando... ');
      service.deleteCalendarHoliday(item.id).subscribe(
        (res) => {
          this.loader.stop();
          this.toast.show('Feriado excluído com sucesso', 'success');
          this.load();
        },
        (error) => {
          this.loader.stop();
          this.showToastApiError(error);
        }
      );
    };

    this.dialog.show(
      'error',
      'Exclusão de feriado',
      `Deseja excluir o feriado selecionado "${item.dataFmt} - ${item.nome}"?`,
      'Voltar',
      '',
      'Excluir',
      deleteAction
    );
  }
}
